module.exports = __webpack_public_path__ + "img/pa2020_e.e094167d.jpg";